__turbopack_context__.v({
  "container": "FavouritesButton-module__A_tCTa__container",
  "heartClickSpring": "FavouritesButton-module__A_tCTa__heartClickSpring",
  "heartHoverFill": "FavouritesButton-module__A_tCTa__heartHoverFill",
});
